module.exports = __webpack_public_path__ + "img/VN.a34fde21.svg";